import { api } from '@/api/client'

export interface UkmReceiptItem {
  id: number
  line_no: number
  name: string
  barcode: string | null
  scu: string | null
  measure: string | null
  qty: number
  price: number
  discount: number
  line_total: number
  pos_event_id: number | null
  frame_ts_us: number | null
  taxes?: Array<{ percent: number | null; amount: number }>
}

export interface UkmReceiptPayment {
  id: number
  type: string | null
  amount: number
}

export interface UkmReceiptSideEvent {
  id: number
  type: string
  type_label: string
  text: string | null
  price: number | null
  event_ts_us: number | null
  is_alert: boolean
}

export interface UkmReceipt {
  id: number
  terminal_id: number
  store_id: number | null
  receipt_number_in_shift: string | null
  global_doc_number: string | null
  op_id: string | null
  state: string | null
  status: 'open' | 'closed' | 'cancelled'
  opened_at_msk: string | null
  closed_at_msk: string | null
  total: number
  discount_total: number
  payment_total: number
  tax_total?: number
  client_card: string | null
  client_name: string | null
  client_balance?: number | null
  last_synced_at: string | null
  items: UkmReceiptItem[]
  removed_items?: Array<{ key: string; name: string; price: number }>
  payments: UkmReceiptPayment[]
  side_events: UkmReceiptSideEvent[]
  alert_count: number
}

export interface UkmReceiptStats {
  day: string
  timezone: string
  receipt_count: number
  sum_closed: number
  avg_closed: number
  discount_sum: number
  open_count: number
  alerts_linked: number
}

export interface UkmReceiptSyncMeta {
  last_ok_at: string | null
  last_error: string | null
  backoff_until: string | null
  empty_streak: number
}

export async function fetchTerminalReceipts(
  terminalId: number,
  opts?: { limit?: number; day?: string },
): Promise<UkmReceipt[]> {
  const q = new URLSearchParams()
  if (opts?.limit) q.set('limit', String(opts.limit))
  if (opts?.day) q.set('day', opts.day)
  const qs = q.toString()
  const data = await api<{ receipts?: UkmReceipt[] }>(
    `/api/terminals/${terminalId}/receipts${qs ? `?${qs}` : ''}`,
  )
  return data.receipts || []
}

export async function fetchCurrentReceipt(terminalId: number): Promise<{
  receipt: UkmReceipt | null
  sync: UkmReceiptSyncMeta | null
  ukm5: boolean
}> {
  return api(`/api/terminals/${terminalId}/receipts/current`)
}

export async function fetchReceiptStats(
  terminalId: number,
  day?: string,
): Promise<UkmReceiptStats> {
  const q = day ? `?day=${encodeURIComponent(day)}` : ''
  return api(`/api/terminals/${terminalId}/receipts/stats${q}`)
}
